import { NgModule , CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgChartsModule } from 'ng2-charts';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ChartistModule } from 'ng-chartist';
import { SharedModule } from '../../shared/shared.module';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { UltimosLotesCompletadosRoutingModule } from './ultimos-lotes-completados-routing.module';
import { UltimosLotesCompletadosComponent } from './ultimos-lotes-completados/ultimos-lotes-completados.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [UltimosLotesCompletadosComponent],
  imports: [
    CommonModule,    
    SharedModule,
    NgChartsModule,
    Ng2GoogleChartsModule,
    NgxChartsModule,
    ChartistModule,
    NgbCollapseModule,
    UltimosLotesCompletadosRoutingModule , 
    ReactiveFormsModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UltimosLotesCompletadosModule { }
